import { InjectionToken } from "@angular/core";

import { CoreUiErrorsConfig } from "./model";

export const CORE_UI_ERRORS_CONFIG = new InjectionToken<CoreUiErrorsConfig>("coreUiErrorsConfig");

/**
 * @internal
 */
export const _CORE_UI_ERRORS_CONFIG = new InjectionToken<CoreUiErrorsConfig | (() => CoreUiErrorsConfig)>(
	"_coreUiErrorsConfig"
);
